@if (quote.issueType !== undefined) {
  <td-wb-list listSize="compact"
              [embedded]="true"
              itemDivider="bottom"
              class="td-wb-quote-summary"
    aria-labelledby="td-wb-aria-security-info-title" >
    <ng-container *ngTemplateOutlet="currentTemplate" />
  </td-wb-list>
}

<ng-template #stock>
  <td-wb-detailed-quote-summary-symbol-detail [quote]="quote" />
  <ng-container *ngTemplateOutlet="bidLotsRow" />
  <ng-container *ngTemplateOutlet="askLotsRow" />
  <ng-container *ngTemplateOutlet="openPriceRow" />
  <ng-container *ngTemplateOutlet="volumeRow" />
  <ng-container *ngTemplateOutlet="dayRangeRow" />
  <ng-container *ngTemplateOutlet="yearRangeRow" />
</ng-template>

<ng-template #etf>
  <td-wb-detailed-quote-summary-symbol-detail [quote]="quote" />
  <ng-container *ngTemplateOutlet="openPriceRow" />
  <ng-container *ngTemplateOutlet="bidLotsRow" />
  <ng-container *ngTemplateOutlet="askLotsRow" />
  <ng-container *ngTemplateOutlet="volumeRow" />
</ng-template>

<ng-template #index>
  <td-wb-detailed-quote-summary-symbol-detail [quote]="quote" />
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.OPEN" />
    <td-wb-list-item-value [innerText]="quote.priceOpen | tdWbCurrency: { emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.PREVIOUS_CLOSE" />
    <td-wb-list-item-value [innerText]="quote.previousClose | tdWbCurrency: { emptyPlaceholder: placeholder }" />
  </td-wb-list-item>
  <ng-container *ngTemplateOutlet="dayRangeRow" />
  <ng-container *ngTemplateOutlet="yearRangeRow" />
</ng-template>

<ng-template #mf>
  <td-wb-detailed-quote-summary-symbol-detail [quote]="quote" />
  <!-- Category change width Phase >1.0 -->
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.mf.CATEGORY" />
    @if (quote.fundCategory) {
      <td-wb-list-item-value [innerText]="quote.fundCategory" />
    } @else {
      <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
    }
  </td-wb-list-item>
</ng-template>

<ng-template #option>
  <!-- Underlying quote  -->
  <td-wb-detailed-quote-summary-symbol-detail [quote]="quote.underlyingQuote" />
  <!-- Quote Symbol  -->
  <td-wb-detailed-quote-summary-symbol-detail [quote]="quote"
    [displayName]="false" />
  <ng-container *ngTemplateOutlet="bidLotsRow" />
  <ng-container *ngTemplateOutlet="askLotsRow" />
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.OPEN_INTEREST" />
    <td-wb-list-item-value>
      @if (quote.openInterest) {
        <span [innerText]="quote.openInterest | tdWbNumber: { format: 'n0' }"></span>
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
  <ng-container *ngTemplateOutlet="volumeRow" />
  <ng-container *ngTemplateOutlet="dayRangeRow" />
</ng-template>

<ng-template #openPriceRow>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.OPEN_PRICE" />
    @if (!quote.securityHalted) {
      <td-wb-list-item-value [innerText]="quote.priceOpen | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: placeholder }" />
    }
  </td-wb-list-item>
</ng-template>

<ng-template #bidLotsRow>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label>
      <span translate="tdWb.markets.quote.BID"></span> / <span translate="tdWb.markets.quote.LOTS"></span>
    </td-wb-list-item-label>
    <td-wb-list-item-value>
      @if (quote.bidPrice) {
        <span [innerText]="quote.bidPrice | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: placeholder }"></span> /
        @if (quote.bidLots) {
          <small
            [innerText]="quote.bidLots | tdWbNumber: { format: 'c4-0', emptyPlaceholder: placeholder, shorten: true}">
          </small>
        }
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
</ng-template>

<ng-template #askLotsRow>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label>
      <span translate="tdWb.markets.quote.ASK"></span> / <span translate="tdWb.markets.quote.LOTS"></span>
    </td-wb-list-item-label>
    @if (quote.askPrice) {
      <td-wb-list-item-value>
        <span [innerText]="quote.askPrice | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: placeholder }"></span> /
        @if (quote.askLots) {
          <small
            [innerText]="quote.askLots | tdWbNumber: {  format: 'c4-0', emptyPlaceholder: placeholder, shorten: true}">
          </small>
        }
      </td-wb-list-item-value>
    } @else {
      <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>
    }
  </td-wb-list-item>
</ng-template>

<ng-template #volumeRow>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label translate="tdWb.markets.quote.VOLUME" />
    <td-wb-list-item-value>
      @if (quote.volume) {
        <td-wb-quote-volume-contextual-help [quote]="quote" />
      } @else {
        <span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>&nbsp;
        (<span [innerText]="null | tdWbNumber: { nullPlaceholder: placeholder }"></span>)
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
</ng-template>

<ng-template #dayRangeRow>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label>
      <span translate="tdWb.markets.quote.DAY_RANGE"></span>
      <span translate="tdWb.markets.quote.HIGH_LOW"></span>
    </td-wb-list-item-label>
    <td-wb-list-item-value>
      <span [innerText]="quote.priceHigh | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: '-'}"></span>
      /
      @if (quote.priceLow !== undefined) {
        <span [innerText]="quote.priceLow | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: '-' }"></span>
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
</ng-template>

<ng-template #yearRangeRow>
  <td-wb-list-item class="td-wb-quote-summary__row">
    <td-wb-list-item-label>
      <span translate="tdWb.markets.quote.FIFTY_TWO_WEEK_RANGE"></span>
      <span translate="tdWb.markets.quote.HIGH_LOW"></span>
    </td-wb-list-item-label>
    <td-wb-list-item-value>
      <span [innerText]="quote.priceHigh52W | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: '-'}"></span>
      /
      @if (quote.priceLow52W !== undefined) {
        <span [innerText]="quote.priceLow52W | tdWbCurrency : { format: 'c4-2', emptyPlaceholder: '-' }"></span>
      }
    </td-wb-list-item-value>
  </td-wb-list-item>
</ng-template>


